module.exports = __webpack_public_path__ + "static/img/8.2e66471.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/1/eng/8.png
// module id = TE1R
// module chunks = 0